import React from "react";
import abourUsOne from "../../Images/Aboutoneimg.png";
import abourUsTwo from "../../Images/Amitha-e1701184049650.jpg";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
// import "../NavbarLinksCSS/AboutUs.css";
import aboutbannerImg from "../../AVHRBanner/AboutUSbannerT2.png";
import whyabout from "../../Images/WhyAboutimg.png";

function AboutPage() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const benefits = [
    {
      icon: "🎓",
      title: "Certified Leadership Coach",
      description:
        "PCC-certified Executive & Leadership Coach (ICF), personally trained by John Mattone under the Intelligent Leadership™ methodology.",
      color: "#e3f2fd",
    },
    {
      icon: "💫",
      title: "Holistic Coaching Expertise",
      description:
        "Certified in Emotional Intelligence, NLP, Corporate Training, Psychology, and Facilitation for a well-rounded coaching approach.",
      color: "#f3e5f5",
    },
    {
      icon: "🌍",
      title: "Global Leadership Impact",
      description:
        "Worked with leaders around the world, helping them elevate their impact within their organizations.",
      color: "#e8f5e9",
    },
    {
      icon: "🤝",
      title: "Trusted by Fortune 500",
      description:
        "Partnered with Fortune 500 clients to support their professional and personal development journeys.",
      color: "#fff3e0",
    },
    {
      icon: "📅",
      title: "20+ Years of Experience",
      description:
        "Our experts bring over 20 years of corporate training experience and 2800+ hours of executive coaching.",
      color: "#ede7f6",
    },
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={aboutbannerImg}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">
                HR Consulting Services
              </p>

              <h1 className="career-library-heading">About AV-CS</h1>

              <p className="mt-2 leading-relaxed">
                In today’s evolving workplace, our brand stands out for its
                excellence and passion
              </p>
            </div>
          </div>
        </div>

        <div className="grid align-items-center px-3 md:px-6 pt-4 md:pt-6">
          <div className="col-12 md:col-6 mb-4 md:mb-0">
            <img
              src={abourUsOne}
              alt="About Us"
              className="w-full border-round-lg shadow-4"
            />
          </div>

          <div className="col-12 md:col-6">
            <h1 className="avhrProject-h1 mb-2">Why Choose AV-CS?</h1>
            <p className="avhrProject-p">
              AV-CS brings over three decades of extensive and profound industry
              experience across the entire Human resources lifecycle, along with
              the exceptional knowledge honed from IIMs ensuring agile solutions
              and seamless services.
            </p>
            <div className="avhrProject-quote">
              <b>
                <i>
                  “Enriching Human Capital, Where Expertise Meets Empowerment”
                </i>
              </b>
            </div>
          </div>
        </div>

        {/* Design One */}
        <div className="px-3 md:px-6 pt-4">
          <div className="text-start mb-5">
            <h2 className="avhrProject-h1 mb-2">
              AV-CS Coaching And Facilitation
            </h2>
            <p className="avhrProject-p">
              Our approach integrates proven methods such as the GROW model,
              strengths-based coaching, and systems thinking, alongside tools
              like 360-degree feedback, personality assessments, and customized
              action plans. These techniques empower leaders to navigate complex
              challenges, enhance their skills and achieve meaningful
              transformations that drive lasting success.
              <br />
              <br />
              Our mission is to cultivate value-driven leaders who can create
              meaningful impact, navigate change effectively, achieve
              sustainable growth and success by aligning their actions with
              purpose, values, and excellence. We support leadership transitions
              and career shifts with clarity and confidence, and help you manage
              change effectively. Our coaching sessions are solution-focused,
              strengths-based, and deeply reflective.
              <br />
              <br />
              <b>
                When it comes to Coaching and Facilitation, our experts are...
              </b>
            </p>
          </div>
          <div className="flex flex-column gap-4">
            <div className="flex flex-wrap justify-content-center gap-4">
              {[
                {
                  icon: "🎓",
                  title: "Certified Leadership Coach",
                  description:
                    "PCC-certified Executive & Leadership Coach (ICF), personally trained by John Mattone under the Intelligent Leadership™ methodology",
                },
                {
                  icon: "💫",
                  title: "Holistic Coaching Expertise",
                  description:
                    "Certified in Emotional Intelligence, NLP, Corporate Training, Psychology, and Facilitation for a well-rounded coaching approach",
                },
                {
                  icon: "🌍",
                  title: "Global Leadership Impact",
                  description: "We have worked with leaders worldwide",
                },
              ].map((service, index) => (
                <div
                  key={index}
                  className="w-full md:w-5 lg:w-3 flex align-items-stretch"
                >
                  <div className="p-3 shadow-2 text-center border-round-lg h-full card-hover-effect flex flex-column w-full">
                    <div className="text-5xl mb-1">{service.icon}</div>
                    <div className="flex-grow-1">
                      <h3 className="mb-2 avhrProject-h4">{service.title}</h3>
                      <p className="mb-2 avhrProject-p">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap justify-content-center gap-4">
              {[
                {
                  icon: "🤝",
                  title: "Trusted by Fortune 500",
                  description:
                    "Our experts worked with Fortune 500 clients to support both professional and personal growth journeys",
                },
                {
                  icon: "📅",
                  title: "20+ Years of Experience",
                  description:
                    "Our experts bring over 20 years of corporate training experience and 2800+ hours of Executive coaching",
                },
              ].map((service, index) => (
                <div
                  key={index}
                  className="w-full md:w-6 lg:w-3 flex align-items-stretch"
                >
                  <div className="p-3 shadow-2 text-center border-round-lg h-full card-hover-effect flex flex-column w-full">
                    <div className="text-5xl mb-1">{service.icon}</div>
                    <div className="flex-grow-1">
                      <h3 className="mb-2 avhrProject-h4">{service.title}</h3>
                      <p className="mb-2 avhrProject-p">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="px-3 md:px-6 pt-4">
          <h1 className="avhrProject-h1 mb-3 text-center md:text-left">
            Leadership Team
          </h1>

          <div className="grid md:align-items-center">
            <div className="col-12 md:col-4 text-center md:mb-0">
              <img
                src={abourUsTwo}
                className="w-10rem sm:w-12rem md:w-14rem border-round-lg shadow-4"
                alt="Amitha Kolli"
                style={{ maxWidth: "100%", height: "auto" }}
              />
              <p className="avhrProject-p">
                <strong>Amitha Kolli</strong>
                <br />
                <strong>Founder & CEO</strong>
              </p>
            </div>

            <div className="col-12 md:col-8">
              <p className="avhrProject-p text-justify">
                <b>Amitha Kolli</b> carries three decades of vast experience.
                She is a renowned Global HR Leader and has been in the HR and
                Operations space for around 25 years. Her learnings from top
                B-schools like IIM Ahmedabad and Symbiosis have added to her
                vision of founding <b>AV-CS</b>. In her initial stages of her
                career, she has worked with the Department of Atomic Energy,
                India on computer software and hardware projects. Later, she
                found her passion in people and Human relations and has dived
                deep into the HR world wherein she excelled into an influential
                Leader at top Multinational companies.
                <br />
                <br />
                Having a varied industrial exposure, she brings in the right mix
                of experience and strategies to the business. She has built
                strong teams, fostered highly engaged cultures and has always
                showcased the vital role of HR in the success of business. She
                has great expertise in managing high volumes of growth and has
                played crucial role in upscaling business models.
                <br />
                <br />
                Carrying her passion for people, as Founder and CEO of{" "}
                <b>AV-CS</b>, Amitha wants to help businesses to build best
                cultures and strong teams. With an empathetic Leadership style,
                she has an excellent understanding of people dynamics. Her
                astute management processes have and will ensure seamless growth
                and sustenance of the organizations. Her reputation as a highly
                dependable Leader will be a key in client success.
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-2"
            style={{
              background: "linear-gradient(120deg, #F57373, #FFD54F, #FFFFFF)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Ready to take the first step
              <br />
              We’re here to help
            </h2>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default AboutPage;
